var React = require('react');

function Dk (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#c8102e","d":"M0 0h640.1v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M205.7 0h68.6v480h-68.6z","key":1}),React.createElement("path",{"fill":"#fff","d":"M0 205.7h640.1v68.6H0z","key":2})]);
}

Dk.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Dk;

Dk.default = Dk;
